import { render, staticRenderFns } from "./ClosingPage.vue?vue&type=template&id=4ed9e396&scoped=true&"
import script from "./ClosingPage.vue?vue&type=script&lang=js&"
export * from "./ClosingPage.vue?vue&type=script&lang=js&"
import style0 from "./ClosingPage.vue?vue&type=style&index=0&id=4ed9e396&lang=scss&scoped=true&"
import style1 from "./ClosingPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9e396",
  null
  
)

export default component.exports